import { useEffect, useRef, useState } from "react"
import axios from "axios"
import LogoItau from "@mobi/ds/static/icons/filled/logo-itau.svg"
import If from "@mobi/components/If"
import DropdownApp from "./components/DropdownApp"
import DropdownForm from "./components/DropdownForm"
import MobileAppMenu from "./components/MobileAppMenu"
import { Branch } from "./components/Forms"
import IconPlus from "@mobi/ds/static/icons/outlined/mais.svg"

import FormHidden from "./components/FormHidden"

import useHeader from "./useHeader"

import useMediaQuery from "@mobi/hooks/useMediaQuery"

import focusInElement from "@mobi/utils/browser/focusInElement"
import { BackIcon, CloseIcon } from "./utils/icons"
import { Link, Button } from "@mobi/ds"

import "./Header.scss"
import DropdownMenu from "./components/DropdownMenu"

const Header = ({
  prevUrl,
  prevAction,
  prevLabel,
  prevRole,
  home,
  logoLink,
  onClickLogo,
  logoUrl,
  logoAppUrl,
  logoDescription,
  resetFocusOnMount,
  mobileInfosApp,
  handleOpenAccountLink = () => {},
  handleMenuOpenAccountLink = () => {},
  handleSubmenuOpenAccountLink = () => {},
  openAccountLink,
  utmsHeaderOpenAccount = "",
  utmsHeaderMenuCheckingAccount = "",
  utmsHeaderMenuOpenAccount = "",
}) => {
  const {
    toggleDropDown,
    register,
    handleSubmit,
    onSubmitForm,
    toggle,
    currentForm,
    isValid,
    control,
    toggleSiblings,
  } = useHeader()

  const [menuContent, setMenuContent] = useState({})
  const [menuData, setMenuData] = useState(null)

  const toggleMenu = (menuIndex) => {
    let newMenuList = [...menuList]
    newMenuList = newMenuList.map((menu, index) => {
      if (menuIndex === index) {
        menu.show = !menu.show
      } else {
        menu.show = false
      }
      return menu
    })
    setMenuList(newMenuList)
  }

  const [menuList, setMenuList] = useState([
    {
      label: "para você",
      action: toggleMenu,
      id: 1,
      type: "menu",
      show: false,
    },
    {
      label: "para empresas",
      type: "link",
      id: 2,
      action: "https://www.itau.com.br/empresas",
      show: false,
    },
    {
      label: "acesse sua conta",
      type: "menu",
      id: 2,
      action: toggleMenu,
      content: (
        <MobileAppMenu
          mobileInfosApp={mobileInfosApp}
          logoAppUrl={logoAppUrl}
        />
      ),
      show: false,
      isMobile: true,
    },
    {
      label: "ajuda",
      type: "menu",
      id: 3,
      action: toggleMenu,
      show: false,
    },
  ])
  const getMenuData = (submenuName) => {
    axios
      .get(
        'https://cdn.contentstack.io/v3/content_types/paginas_personalizacao/entries?environment=prod&include[]=template_selection&query={"url":"/home"}',
        {
          headers: {
            ACCESS_TOKEN: `cs29cd832edffb71c605e1faa7`,
            API_KEY: "blt1d56cfda202168c5",
          },
        }
      )
      .then(({ data }) => {
        setMenuContent(
          data.entries[0].template_selection[0].header.menu[submenuName]
        )
        setMenuData(data)
      })
  }

  useEffect(() => {
    const selectedMenu = menuList?.find(({ show }) => show)
    if (selectedMenu) {
      const submenuName = `submenu_item_${selectedMenu.id}`
      if (!menuData) {
        getMenuData(submenuName)
      } else {
        setMenuContent(
          menuData.entries[0].template_selection[0].header.menu[submenuName]
        )
      }
    }
  }, [menuList])

  const isMobile = useMediaQuery("mobile")

  useEffect(() => {
    resetFocusOnMount &&
      focusInElement(".ds-header__logo-link", { timeout: 300 })
  }, [])

  useEffect(() => {
    toggleSiblings(toggle)
    addEventListener("scroll", toggleMenu)
    return () => {
      removeEventListener("scroll", toggleMenu)
    }
  }, [toggle])

  const forms = {
    branch: {
      form: <Branch control={control} register={register} />,
      textButton: "agência e conta",
      formhidden: (
        <FormHidden
          actionPost={"https://internetpf.itau.com.br/router-app/router"}
          portalValue={"006"}
          typeLogon={"7"}
        >
          <input type="hidden" data-branch name="usuario.agencia" value="" />
          <input type="hidden" data-account name="usuario.conta" value="" />
          <input type="hidden" data-acc name="usuario.dac" value="" />
        </FormHidden>
      ),
    },
  }

  return (
    <>
      <header className={`ds-header ${!home ? "ds-header--inner" : ""}`}>
        <div className="ds-header__container" style={{ maxWidth: 1216 }}>
          <div className="ds-header__logo">
            <a
              href={logoLink}
              onClick={onClickLogo}
              aria-label={logoDescription}
              tabIndex="0"
              data-unique="fe8c28e9-765f-441d-ad45-da69a51ec245"
              className="ds-header__logo-link"
              role="button"
            >
              <If
                condition={logoUrl}
                renderIf={
                  <img
                    src={logoUrl}
                    width={48}
                    height={48}
                    alt={logoDescription}
                    className={`ds-header__logo-image`}
                  />
                }
                renderElse={<LogoItau />}
              />
            </a>
          </div>

          <If
            condition={!home}
            renderIf={
              <If
                condition={isMobile}
                renderIf={
                  <button
                    className="ds-header__button-back"
                    onClick={(e) => {
                      if (prevUrl) window.location.href = prevUrl
                      prevAction && prevAction(e)
                    }}
                    aria-label="fechar"
                    role={prevRole}
                    id="main-logo"
                  >
                    <CloseIcon />
                  </button>
                }
                renderElse={
                  <a
                    className="ds-header__button-back"
                    href={prevUrl}
                    onClick={prevAction && prevAction}
                    aria-label={prevLabel || "voltar para o início"}
                    role={prevRole}
                    id="main-logo"
                  >
                    <BackIcon />
                    {prevLabel || "voltar para o início"}
                  </a>
                }
              />
            }
            renderElse={
              <>
                <div className="ds-header__content">
                  <nav className="ds-header__menu">
                    <ul className="ds-header__menu-list">
                      {menuList.map(
                        ({ type, action, label, isMobile }, index) => {
                          if (isMobile) return false
                          const actionList = () => action(index)
                          const isShow = menuList[index].show
                          const buttonRef = useRef(null)
                          return (
                            <li key={`dropdown-menu-item-${label}`}>
                              {type === "menu" ? (
                                <button
                                  ref={buttonRef}
                                  className={`ds-header__menu-item ${
                                    isShow ? "ds-header__menu-item--active" : ""
                                  }`}
                                  data-menu-index="0"
                                  onClick={actionList}
                                  aria-expanded={isShow}
                                >
                                  <span>{label}</span>
                                </button>
                              ) : (
                                <span className={`ds-header__menu-item`}>
                                  <a href={action}>{label}</a>
                                </span>
                              )}
                              <DropdownMenu
                                key={`dropdownmenu-${label}`}
                                menuContent={menuContent}
                                toggleMethod={actionList}
                                show={isShow}
                                actionButtonRef={buttonRef}
                                handleMenuOpenAccountLink={
                                  handleMenuOpenAccountLink
                                }
                                utmsHeaderMenuCheckingAccount={
                                  utmsHeaderMenuCheckingAccount
                                }
                                utmsHeaderMenuOpenAccount={
                                  utmsHeaderMenuOpenAccount
                                }
                                handleSubmenuOpenAccountLink={
                                  handleSubmenuOpenAccountLink
                                }
                              />
                            </li>
                          )
                        }
                      )}
                    </ul>
                  </nav>
                </div>
                <DropdownForm
                  currentForm={forms[currentForm]}
                  toggle={toggle}
                  handleSubmit={handleSubmit}
                  onSubmitForm={onSubmitForm}
                  isValid={isValid}
                />
                <Link
                  className="ds-header__more-access"
                  href="https://www.itau.com.br/servicos/mais-acessos"
                  role="button"
                >
                  <IconPlus />
                  <span>acessos</span>
                </Link>
                <Button
                  className="ds-header__account-button"
                  variant="secondary"
                  tagName="a"
                  href={`${openAccountLink}${utmsHeaderOpenAccount}`}
                  target="_blank"
                  rel="noreferrer"
                  onClick={handleOpenAccountLink}
                  role="button"
                >
                  abra sua conta
                </Button>
                <DropdownApp
                  mobileInfosApp={mobileInfosApp}
                  toggleDropDown={toggleDropDown}
                  toggle={toggle}
                  logoAppUrl={logoAppUrl}
                  menuList={menuList}
                  menuContent={menuContent}
                  handleMenuOpenAccountLink={handleMenuOpenAccountLink}
                  utmsHeaderMenuCheckingAccount={utmsHeaderMenuCheckingAccount}
                  handleSubmenuOpenAccountLink={handleSubmenuOpenAccountLink}
                  utmsHeaderMenuOpenAccount={utmsHeaderMenuOpenAccount}
                />
              </>
            }
          />
        </div>
      </header>
      <div
        className={`ds-header__spacer ${
          !home ? "ds-header__spacer--inner" : ""
        }`}
      />
    </>
  )
}

Header.defaultProps = {
  home: true,
  prevUrl: "/",
  logoLink: "/",
  logoDescription: "Logo Itaú",
  onClickLogo: () => {},
  resetFocusOnMount: false,
  mobileInfosApp: {
    title: "Para acessar a sua conta , você precisa baixar o aplicativo.",
    name: "app Itaú",
    description:
      "Um app cada vez mais completo, para você contar com diversos serviços do banco direto do celular.",
    link: "https://www.itau.com.br/",
    textLink: "baixar app",
  },
  openAccountLink:
    "https://www.itau.com.br/contas/conta-corrente?utm_source=st&utm_medium=nd&utm_campaign=st-conv-nd-st-nd-all&utm_content=nd-nd-nd-iacnta-nd-pfaqu-MT00001342-rvproduto",
}

export default Header
